import { defer as tanstackDefer } from '@tanstack/react-router';

export const defer = <S = unknown>(_promise: Promise<S>, timeout?: number) => {
  const promise = new Promise((resolve, reject) => {
    _promise
      .then(
        timeout === undefined
          ? resolve
          : (...args) => {
              setTimeout(() => {
                resolve(...args);
              }, timeout);
            },
      )
      .catch(reject);
  });

  return tanstackDefer(promise);
};
